import React from 'react';
import { ProjectLogo } from '../types';
export var ClientLogo = function (_a) {
    var className = _a.className, client = _a.client, noLogo = _a.noLogo, projectLogo = _a.projectLogo;
    var logoToShow = function () {
        var _a, _b, _c;
        if (projectLogo === ProjectLogo.INFLOW && ((_b = (_a = client.logos) === null || _a === void 0 ? void 0 : _a.inflow) === null || _b === void 0 ? void 0 : _b.svg)) {
            return client.logos.inflow.svg;
        }
        return (_c = client.logos) === null || _c === void 0 ? void 0 : _c.svg;
    };
    var logo = logoToShow();
    if (!logo)
        return noLogo || React.createElement("span", null, "client.name");
    return (React.createElement("div", { className: className, dangerouslySetInnerHTML: {
            __html: logo
        } }));
};
//# sourceMappingURL=client-logo.js.map